const isMobile = () => {
    return window.innerWidth < 768;
}

const getDisplayMode = () => {
    return isMobile() ? 'mobile' : 'desktop';
}

let currentVideoDisplayMode = getDisplayMode();

const getSplitVideos = () => {
    return document.querySelectorAll('.splitVideo__video');
}

const initSplitVideos = () => {
    const videos = getSplitVideos();
    if (videos.length === 0) return false;

    videos.forEach(video => {
        const { desktopMp4, desktopwebm, mobilemp4, mobilewebm } = getSourceUrls(video);

        if (currentVideoDisplayMode === 'mobile') {
            setVideoSource(video, mobilemp4, mobilewebm);
        } else {
            setVideoSource(video, desktopMp4, desktopwebm);
        }

        video.setAttribute('video-display', currentVideoDisplayMode);
    });
}

const onWindowResize = () => {
    const newDisplayMode = getDisplayMode();

    if (newDisplayMode != currentVideoDisplayMode) {
        currentVideoDisplayMode = newDisplayMode;
        initSplitVideos();
    }
}

window.addEventListener('resize', () => {
    window.requestAnimationFrame(() => {
        onWindowResize();
    });
}, true);

// Remove any existing sources and then add the new types with urls
const setVideoSource = (videoElem, mp4, webm) => {
    videoElem.querySelectorAll('source').forEach(elem => elem.remove());

    if (mp4) {
        const sourceMp4 = document.createElement('source');
        sourceMp4.type = "video/mp4";
        sourceMp4.src = mp4;
        videoElem.append(sourceMp4);
    }
    
    if (webm) {
        const sourceWebM = document.createElement('source');
        sourceWebM.type = "video/webm";
        sourceWebM.src = webm;
        videoElem.append(sourceWebM);
    }

    videoElem.load();
}

const getSourceUrls = (videoElem) => {
    const desktopMp4 = videoElem.getAttribute('data-desktop-mp4') || null;
    const desktopwebm = videoElem.getAttribute('data-desktop-webm') || null;
    const mobilemp4 = videoElem.getAttribute('data-mobile-mp4') || null;
    const mobilewebm = videoElem.getAttribute('data-mobile-webm') || null;

    return {
        desktopMp4,
        desktopwebm,
        mobilemp4,
        mobilewebm
    }
}
export {
    initSplitVideos
}